// extracted by mini-css-extract-plugin
export default {"input-container":"AuthStyles_input-container__f9o32","error-msg":"AuthStyles_error-msg__BplN6"};